import React, { useContext, useState } from "react"
import axios from "axios"

const BASE_URL = "http://localhost:3000/api/v1/"

const GlobalContext = React.createContext()


export const GlobalProvider  = ({children}) => {

    const [incomes,setIncomes] = useState([])
    const [expenses,setExpenses] = useState([])
    const[error,setError] = useState(null)

    //calculate incomes
    const addIncome = async (income) => {
        const response = await axios.post(`${BASE_URL}add-income`,income)
        .catch((err) => {
            setError(err.response.data.message)
        })
        getIncomes()
    }

    const getIncomes = async () => {
        const response = await axios.get(`${BASE_URL}get-incomes`)
        setIncomes(response.data)
        console.log(response.data)

    }

    const deleteIncome = async (id) => {
        const res  = await axios.delete(`${BASE_URL}delete-income/${id}`)
        getIncomes()
    }

    const totalIncome = () => {
        let totalIncome = 0;
        incomes.forEach((income) => {
             totalIncome = totalIncome + income.amount
        })

        return totalIncome;
    }

    console.log(totalIncome)

    //calculate expense
    const addExpense = async (income) => {
        const response = await axios.post(`${BASE_URL}add-expense`,income)
        .catch((err) => {
            setError(err.response.data.message)
        })
        getExpense()
    }

    const getExpense = async () => {
        try{
        const response = await axios.get(`${BASE_URL}get-expenses`)
        setExpenses(response.data)
        console.log(response.data)
        }
        catch (error) {
            console.error('Error fetching expenses:', error);
            throw error;
          }

    }

    const deleteExpense= async (id) => {
        const res  = await axios.delete(`${BASE_URL}delete-expense/${id}`)
        getExpense()
    }

    const totalExpense = () => {
        let totalIncome = 0;
        expenses.forEach((income) => {
             totalIncome = totalIncome + income.amount
        })

        return totalIncome;
    }

    const totalBalance = () => {
        return totalIncome() - totalExpense()

    }

    const transactionHistory = () => {
        const history = [...incomes, ...expenses]
        history.sort((a,b) =>{
            return new Date(b.createdAt) - new Date(a.createdAt)
        })
        return history
    }


    return(
    <GlobalContext.Provider value={{
        addIncome,
        getIncomes,
        incomes,
        deleteIncome,
        totalIncome,

        addExpense,
        getExpense,
        expenses,
        deleteExpense,
        totalExpense,

        totalBalance,

        transactionHistory,

        error,
        setError
    }}>
        {children}
    </GlobalContext.Provider>
    )

}
export const useGlobalContext = () =>{
    return useContext(GlobalContext)
}